import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

class ScrollMessageAnimation {
  constructor(el) {
    this.dom = {el: el};

    gsap.registerPlugin(ScrollTrigger);

    this.init();
  }

  init() {
    ScrollTrigger.create({
      trigger: this.dom.el,
      id: 'message',
      start: 'top top-=50',
      end: 'bottom -500%',
      toggleClass: {
        targets: this.dom.el,
        className: 'is-show'
      },
      once: false,
      markers: false,
    });
  }
}

export default ScrollMessageAnimation